import styled, { css } from "styled-components";
import { shade, rgba } from "polished";
import { tokens } from "../../../design/tokens";

interface ContainerProps {
  enabled?: boolean;
  contrast?: boolean;
  bolder?: boolean;
  noShaddow?: boolean;
  shimmer?: boolean;
  customStyle?: string;
  state?: string;
}

export const Container = styled.button<ContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;

  background: ${tokens.color.marqueeGold};
  border-radius: 8px;
  height: 44px;
  border: 0;
  padding: 0 20px;
  /* min-width: 154px; */

  box-shadow: none;

  margin-top: ${tokens.space.lg};
  transition: background-color 0.2s;

  font-family: ${tokens.font.label.family};
  font-size: 15px;
  font-weight: ${tokens.font.label.weight};
  color: ${tokens.color.inkCharcoal};
  text-transform: uppercase;
  letter-spacing: 0.5px;

  .signuppayment {
    margin-top: 0px;
  }

  &:disabled {
    opacity: 0.7 !important;
    pointer-events: none;
  }

  &:hover {
    background: ${shade(0.15, tokens.color.marqueeGold)};
    cursor: pointer;
  }

  ${(props) =>
    props.state === "danger" &&
    css`
      background: #f15057;
      color: #fff;
    `}

  ${(props) =>
    props.bolder
      ? css`
          font-weight: lighter !important;
        `
      : css`
          font-weight: bolder !important;
        `}

  ${(props) =>
    props.noShaddow &&
    css`
      box-shadow: none;
    `}

  ${(props) =>
    props.enabled === false &&
    css`
      opacity: 0.4;
      pointer-events: none;
    `}

  ${(props) =>
    props.contrast &&
    css`
      background: ${rgba(tokens.color.marqueeGold, 0.14)};
      border: solid 2px ${tokens.color.marqueeGold};
      color: ${tokens.color.marqueeGold};

      box-shadow: none;

      /* O hover solido acima (background dourado escurecido) e pensado pro
         botao primario, mas se aplica a qualquer botao por causa do seletor
         &:hover generico. Sem isso, o texto dourado do contrast some sobre
         o fundo tambem dourado que o hover padrao força. */
      &:hover {
        background: ${rgba(tokens.color.marqueeGold, 0.28)};
        color: ${tokens.color.marqueeGold};
      }
    `}



  ${(props) =>
    props.shimmer &&
    css`
      animation: buttonShimmer 2s ease-in-out infinite;
    `}

  ${(props) =>
    props.customStyle === "success" &&
    css`
      background: #04b530;
      color: #fff;
    `}

  ${(props) =>
    props.customStyle === "danger" &&
    css`
      background: #bf0202;
      color: #fff;
    `}

    ${(props) =>
    props.customStyle === "call" &&
    css`
      background: #00aeca;
      color: #fff;

      transition: 0.4s;

      &:hover {
        background: rgba(0, 174, 202, 0.4);
      }
    `}

  ${(props) =>
    props.contrast &&
    props.customStyle === "call" &&
    css`
      background: #00aeca;
      border: solid 2px #3fe4ff;
      color: #fff;

      box-shadow: none;
      transition: 0.4s;

      &:hover {
        background: rgba(0, 174, 202, 0.4);
      }
    `}
  ${(props) =>
    props.customStyle === "white" &&
    css`
      background: #fff;
      border: solid 2px #353536;
    `}

  svg {
    font-size: 18px;
    margin-right: 4px;
  }
  ${(props) =>
    props.contrast &&
    props.customStyle === "selected" &&
    css`
      background: rgb(254, 212, 74);
      border: none;
      color: rgb(53, 53, 54);
      font-weight: bolder !important;

      transition: 0.4s;

      &:hover {
        opacity: 0.5;
      }
    `}

  /* rgba(255, 211, 92) nao e o Ouro de Marquise — o ouro e rgb(254, 212, 74).
     Eram dois amarelos a um fio de distancia, e o shimmer usava o errado. */
  @keyframes buttonShimmer {
    0% {
      background: ${rgba(tokens.color.marqueeGold, 0.4)};
    }
    50% {
      background: ${rgba(tokens.color.marqueeGold, 0.8)};
    }
    100% {
      background: ${rgba(tokens.color.marqueeGold, 0.4)};
    }
  }
`;
